import React from 'react';
import { motion } from 'framer-motion';
export function SpiritualBackground() {
  return <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden bg-[#F7F7F5]" data-id="element-313">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#F7F7F5] via-[#F7F7F5] to-[#F0F0EE]" data-id="element-314" />

      {/* Minimal drifting circle 1 - Turquoise */}
      <motion.div className="absolute top-[20%] left-[10%] w-[500px] h-[500px] rounded-full bg-[#5BBFB5] opacity-[0.03] blur-[100px]" animate={{
      x: [0, 50, 0],
      y: [0, 30, 0]
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-315" />

      {/* Minimal drifting circle 2 - Warm Gray */}
      <motion.div className="absolute bottom-[20%] right-[10%] w-[600px] h-[600px] rounded-full bg-[#3A3A3A] opacity-[0.02] blur-[120px]" animate={{
      x: [0, -40, 0],
      y: [0, -40, 0]
    }} transition={{
      duration: 25,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} data-id="element-316" />
    </div>;
}